export default __webpack_public_path__ + "static/media/mode-514.39c1e403.svg";